// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cRtT","buttons":"styles_buttons__mCuC2"};